// src/lib/journeySink/constants.ts
// Login-page entry capture for the Shopify-entry tracking properties that ride
// on every analytics event (via_shopify, shop, is_icp, store_url, entry_kind).

// sessionStorage: the login-page params, fresh per tab (same reasoning as
// modules/Auth/store/shopifyEntryStorage).
export const JOURNEY_ENTRY_STORAGE_KEY = 'zoko_journey_entry'

export const REDIRECT_URI_PARAM = 'redirect_uri'
export const SHOP_PARAM = 'shop'
export const STORE_URL_PARAM = 'store_url'
export const IS_ICP_PARAM = 'is_icp'

// How the session arrived, read off the login-page redirect_uri. The install
// hand-off lands on /store-matcher; a merchant opening the app from Shopify
// Admin → Apps lands on /store-switch. Both carry a shop, and a funnel that
// only reads `shop` counts the second as an install.
export const ENTRY_ROUTE_MARKERS = {
  install: 'store-matcher',
  admin_entry: 'store-switch',
} as const

export const ENTRY_KIND = {
  install: 'install',
  admin_entry: 'admin_entry',
} as const
